import Swiper from 'swiper';
import {Navigation,Pagination} from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

export const swiperInit = (options) => {
  const swipers = document.querySelectorAll(options.selector);

  swipers.forEach((swiperEl) => {
    const id = swiperEl.getAttribute('data-id');
    const swiper = new Swiper(`${options.selector}-${id}`, {
      ...options,
      slidesPerView: "auto",
      spaceBetween: 24,
      modules: [Navigation, Pagination],
      direction: 'horizontal',

      breakpoints: options.breakpoints,

      pagination: {
        el: `${options.selector}-${id}-pagination`,
        ...options.pagination,
      },

      navigation: {
        nextEl: `${options.selector}-${id}-button-next`,
        prevEl: `${options.selector}-${id}-button-prev`,
      },
    });
  })
};
